import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { GetMyPostedJobs, JobStatus } from "../../../Redux/Slices/JobPost";
import NoSubscriptionAlert from "./NoSubscriptionAlert";
import { formatDate } from "../../../Helper/FromatTime";
import { GetUserSubscriptions } from "../../../Redux/Slices/Package";
import { FaEdit, FaEye, FaUsers, FaCheckCircle, FaBan } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const PostedJobs = () => {
  const [activeTab, setActiveTab] = useState("approved");
  const [allJobs, setAllJobs] = useState(null);
  const navigate = useNavigate();

  const approvedJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "approved"
  );

  const rejectedJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "rejected"
  );

  const pendingJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "pending"
  );

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
  };

  // Block and Unblock
  const userStatushandler = async (id, data) => {
    const userClickedOK = await window.confirm(
      "Are you sure you want to proceed?"
    );

    if (userClickedOK) {
      let action = { action: data };
      await JobStatus(id, action);
      myjobhnadler();
    }
  };

  const myjobhnadler = async () => {
    let data = await GetMyPostedJobs();
    setAllJobs(data);
  };

  const [salesHistory, setSalesHistory] = useState(null);
  const salesHistoryHandler = async () => {
    let data = await GetUserSubscriptions();
    setSalesHistory(data?.subscriptions);
  };

  const handlePostJobClick = () => {
    navigate("/employer/postjob");
  };

  useEffect(() => {
    myjobhnadler();
    salesHistoryHandler();
    document.title = "Posted Jobs | CAJobPortal";
  }, []);

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'Posted Jobs']}>
        {/* Page Header */}
        <div className="employer-page-header">
          <h1 className="employer-page-title">Posted Jobs</h1>
          <button
            className="employer-btn employer-btn-primary"
            onClick={handlePostJobClick}
          >
            <AiOutlinePlus /> Post New Job
          </button>
        </div>

        {/* Alert */}
        <NoSubscriptionAlert salesHistory={salesHistory} />

        {/* Tabs and Content */}
        <div className="employer-card">
          <div className="employer-tabs">
            <button
              className={`employer-tab ${activeTab === "approved" ? "active" : ""}`}
              onClick={() => handleTabChange("approved")}
            >
              Approved ({approvedJobs?.length || 0})
            </button>
            <button
              className={`employer-tab ${activeTab === "rejected" ? "active" : ""}`}
              onClick={() => handleTabChange("rejected")}
            >
              Rejected ({rejectedJobs?.length || 0})
            </button>
            <button
              className={`employer-tab ${activeTab === "pending" ? "active" : ""}`}
              onClick={() => handleTabChange("pending")}
            >
              Pending ({pendingJobs?.length || 0})
            </button>
          </div>

          {/* Approved Jobs */}
          {activeTab === "approved" && (
            <div className="employer-table-container">
              <table className="employer-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Job Title</th>
                    <th>Posted By</th>
                    <th>Posted Date</th>
                    <th>Industry</th>
                    <th>Applicants</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {approvedJobs && approvedJobs.length > 0 ? (
                    approvedJobs.map((value, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{value?.title}</td>
                        <td>{value?.created_by?.name || "N/A"}</td>
                        <td>{formatDate(value?.posted_date)}</td>
                        <td>{value?.industry?.name || "N/A"}</td>
                        <td>{value?.applications?.length}</td>
                        <td>
                          <div className="employer-flex employer-gap-1">
                            <button
                              onClick={() =>
                                navigate(`/employer/reviewJob/${value?._id}`)
                              }
                              className="employer-btn employer-btn-sm employer-btn-ghost"
                              title="View Details"
                            >
                              <FaEye /> View
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/employer/job-applicants/${value?._id}`)
                              }
                              className="employer-btn employer-btn-sm employer-btn-ghost"
                              title="View Applicants"
                            >
                              <FaUsers /> Applicants
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/employer/editjob/${value?._id}`)
                              }
                              className="employer-btn employer-btn-sm employer-btn-ghost"
                              title="Edit Job"
                            >
                              <FaEdit /> Edit
                            </button>
                            {value?.is_active === true ? (
                              <button
                                onClick={() =>
                                  userStatushandler(value?._id, "false")
                                }
                                className="employer-btn employer-btn-sm employer-btn-danger"
                                title="Deactivate"
                              >
                                <FaBan /> Deactivate
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  userStatushandler(value?._id, "true")
                                }
                                className="employer-btn employer-btn-sm employer-btn-success"
                                title="Activate"
                              >
                                <FaCheckCircle /> Activate
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="employer-table-empty">
                        No approved jobs available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Rejected Jobs */}
          {activeTab === "rejected" && (
            <div className="employer-table-container">
              <table className="employer-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Job Title</th>
                    <th>Posted By</th>
                    <th>Posted Date</th>
                    <th>Industry</th>
                    <th>Reason</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rejectedJobs && rejectedJobs.length > 0 ? (
                    rejectedJobs.map((value, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{value?.title}</td>
                        <td>{value?.created_by?.name || "N/A"}</td>
                        <td>{formatDate(value?.posted_date)}</td>
                        <td>{value?.industry?.name || "N/A"}</td>
                        <td>{value?.remark || "N/A"}</td>
                        <td>
                          <button
                            onClick={() =>
                              navigate(`/employer/reviewJob/${value?._id}`)
                            }
                            className="employer-btn employer-btn-sm employer-btn-ghost"
                          >
                            <FaEye /> View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="employer-table-empty">
                        No rejected jobs available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Pending Jobs */}
          {activeTab === "pending" && (
            <div className="employer-table-container">
              <table className="employer-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Job Title</th>
                    <th>Posted By</th>
                    <th>Posted Date</th>
                    <th>Industry</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingJobs && pendingJobs.length > 0 ? (
                    pendingJobs.map((value, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{value?.title}</td>
                        <td>{value?.created_by?.name || "N/A"}</td>
                        <td>{formatDate(value?.posted_date)}</td>
                        <td>{value?.industry?.name || "N/A"}</td>
                        <td>
                          <button
                            onClick={() =>
                              navigate(`/employer/reviewJob/${value?._id}`)
                            }
                            className="employer-btn employer-btn-sm employer-btn-ghost"
                          >
                            <FaEye /> View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="employer-table-empty">
                        No pending jobs available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </EmployerLayout>
    </div>
  );
};

export default PostedJobs;
